<ol class="breadcrumbs">
    @for (breadcrumb of breadcrumbs(); track $index) {
    <li>
        @switch (breadcrumb.type) { @case ('link') {
        <a class="br-link ph-unmask" [routerLink]="[breadcrumb.value.routerLink]">{{
            breadcrumb.value.text
        }}</a>
        } @case ('text') {
        <span [class.ph-unmask]="breadcrumb.reveal">{{ breadcrumb.value.text }}</span>
        } }
    </li>
    }
</ol>
